export default __webpack_public_path__ + "static/media/prev-GNSS-Receiver-3.7889dc57.png";